<template>
    <b-modal :id="id" dialog-class="modal-lg" @shown="shown" no-close-on-backdrop>
        <template slot="modal-header">
            <span>證照補助</span>
            <b-button class="close" @click="cancel">
                <b-icon-x></b-icon-x>
            </b-button>
        </template>
        <b-overlay :show="loading">
            <studata type="ScholarshipID" :id="modalkey"></studata>
            <table class="table">
                <thead>
                    <tr>
                        <th style="width:200px">助學金種類</th>
                        <th style="width:150px">助學金經費別</th>
                        <th style="width:150px">助學金金額</th>
                        <th style="width:200px">發放日期</th>
                        <th>備註</th>
                        <th></th>
                    </tr>
                </thead>
                <tr v-for="item in vm" :key="item.ScholarshipDetailID">
                    <td data-th="助學金種類">{{item.Project}}</td>
                    <td data-th="助學金經費別">{{item.Type}}</td>
                    <td data-th="助學金金額">{{item.Amount}}</td>
                    <td data-th="發放日期">{{item.Date|date('yyyy/mm/dd')}}</td>
                    <td data-th="備註">{{item.Remark}}</td>
                    <td>
                        <b-button variant="danger" @click="del(item.ScholarshipDetailID)">刪除</b-button>
                    </td>
                </tr>
                <tr>
                    <td data-th="助學金種類">
                        <select v-model="temp.Project" id="Project" class="form-control">
                            <option value="專業技能證照考試補助">專業技能證照考試補助</option>
                            <option value="英文證照考試補助">英文證照考試補助</option>
                        </select>
                    </td>
                    <td data-th="助學金經費別">
                        <input v-model="temp.Type" type="text" class="form-control" />
                    </td>
                    <td data-th="助學金金額">
                        <input v-model="temp.Amount" type="number" class="form-control" />
                    </td>
                    <td data-th="發放日期">
                        <b-form-datepicker class="form-control"
                                           v-model="temp.Date"
                                           :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" label-help="" reset-button />
                    </td>
                    <td data-th="備註">
                        <input v-model="temp.Remark" type="text" class="form-control" />
                    </td>
                    <td>
                        <div class="form-group">
                            <b-button variant="primary" @click="save">儲存</b-button>
                        </div>
                    </td>
                </tr>
            </table>
        </b-overlay>
        <template slot="modal-footer">
            <b-button variant="secondary" @click="cancel"><b-icon-x></b-icon-x>關閉</b-button>
        </template>
    </b-modal>
</template>

<script>
    import studata from '@/views/layout/_studata.vue';

    export default {
        props: ['id', 'modalkey'],
        components: { studata },
        data: function () {
            return {
                vm: [],
                temp: { ScholarshipID: '', Project: '專業技能證照考試補助', Date: new Date() },
                loading: false, saveing: false,
            };
        },
        computed: {
            isedit: function () {
                return this.modalkey !== null;
            },
        },
        methods: {
            shown: function () {
                this.loading = true;
                this.temp.ScholarshipID = this.modalkey;
                this.$http({ method: 'get', url: 'api/ScholarshipDetail/Get/' + this.modalkey + "?type=ScholarshipID" })
                    .then(res => this.vm = res.data)
                    .finally(() => this.loading = false);
            },
            save: function () {
                this.saveing = true;

                this.$http({ method: 'put', url: 'api/ScholarshipDetail/Put', data: this.temp })
                    .then(() => {
                        this.shown();
                    })
                    .finally(() => this.saveing = false);
            },
            del: function (ScholarshipDetailID) {
                this.$http({ method: 'delete', url: 'api/ScholarshipDetail/Delete/' + ScholarshipDetailID })
                    .then(() => {
                        this.shown();
                    })
            },
            cancel: function () {
                this.$emit('reload');
                this.$bvModal.hide(this.id);
            }
        }
    }
</script>

<style>
</style>